export default [
  {
    rate: 5,
    text: 'Truly amazing course! I learned a lot of things about medicine in the shortestamount of time :)',
    author: {
      image: 'user_review.svg',
      name: 'Hanna Marin',
      desc: 'Student'
    }
  },
  {
    rate: 4,
    text: 'Truly amazing course! I learned a lot of things about medicine in the shortestamount of time :)',
    author: {
      image: 'user_review_1.svg',
      name: 'Jake Winston',
      desc: 'Student'
    }
  }
]



// WEBPACK FOOTER //
// ./src/data/reviews.js